import React, { useState } from 'react'
import styled from 'styled-components'

import { Colors } from '../../constants'

const ToolTipContainer = styled.div`
  width: 28px;
  height: 28px;
  background-color: ${Colors.CHARADE};
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`

const ToolTipQuestionMark = styled.div`
  color: ${Colors.WATERLOO};
  font-size: 0.9rem;
  font-weight: 600;
`

const ToolTipMessage = styled.div`
  position: absolute;
  top: 30px;
  left: 30px;
  width: 500px;
  border-radius: 12px;
  padding: 15px;
  background-color: ${Colors.BLACK};
  color: ${Colors.WHITE};
  -webkit-box-shadow: 0px 2px 10px 0px rgba(256, 256, 256, 0.3);
  -moz-box-shadow: 0px 2px 10px 0px rgba(256, 256, 256, 0.3);
  box-shadow: 0px 2px 10px 0px rgba(256, 256, 256, 0.3);
`

export const ToolTip = ({ message = '' }: { message?: React.ReactChild }) => {
  const [show, setShow] = useState(false)
  return (
    <ToolTipContainer
      onMouseLeave={() => setShow(false)}
      onMouseEnter={() => setShow(true)}
    >
      <ToolTipQuestionMark>{'?'}</ToolTipQuestionMark>
      {show && message && <ToolTipMessage>{message}</ToolTipMessage>}
    </ToolTipContainer>
  )
}
